import { Group, Pagination, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/**
 * The footer under every list: how many rows matched, and which page of them is
 * on screen. The API answers `{ items, total }` with `total` counted before the
 * page is cut, which is what makes the count trustworthy.
 */
export function TablePager({
  total,
  limit,
  page,
  onChange,
}: {
  total: number;
  limit: number;
  page: number;
  onChange: (page: number) => void;
}) {
  const { t } = useTranslation();
  const pages = Math.max(1, Math.ceil(total / limit));

  return (
    <Group justify="space-between" mt="md">
      <Text size="sm" c="dimmed">
        {t('common.total', { total })}
      </Text>
      {pages > 1 && <Pagination total={pages} value={page} onChange={onChange} size="sm" />}
    </Group>
  );
}
